import {lazy} from "react";

export const ScheduledSingleVoyagesLazy = lazy(() => import('./ScheduledSingleVoyages'))